import { Checkbox, Theme } from '@mui/material';
import { ATSVacanciesModalTestIds } from 'data-testids/ATS';
import { TableSubtitle, TableTitle } from 'features/TabbedJobView/VacanciesTab/styles';
import { ActiveDistrictSchool } from 'features/TalentMarketplace/TalentFiltersSidebar.types';
import { GroupOfSchools } from 'features/VacanciesModal/types';
import { BasicTableColumn } from 'sharedComponents/Table/BasicTable';
import auth from 'utils/auth';

export const groupSchoolsByGroupId = (schools: ActiveDistrictSchool[]): GroupOfSchools[] => {
  const groupsMap = {};

  schools.forEach((school) => {
    if (school.school_groups.length === 0) {
      if (!groupsMap['nonGrouped']) {
        groupsMap['nonGrouped'] = { groupId: 'nonGrouped', schools: [] };
      }
      groupsMap['nonGrouped'].schools.push(school);
    } else {
      school.school_groups.forEach((rawId) => {
        const groupId = Number(rawId);

        if (!groupsMap[groupId]) {
          groupsMap[groupId] = { groupId, schools: [] };
        }

        groupsMap[groupId].schools.push(school);
      });
    }
  });

  return Object.values(groupsMap);
};

export const getColumns = (
  theme: Theme,
  allChecked: boolean,
  someChecked: boolean,
  selectAllOnClick?: () => void
): BasicTableColumn<string>[] => {
  const isHireLiteDistrict = auth.isAtsLiteDistrict();

  return [
    {
      id: 0,
      content: (
        <Checkbox
          checked={allChecked}
          indeterminate={!allChecked && someChecked}
          sx={{ padding: 0 }}
          onChange={selectAllOnClick}
          disabled={isHireLiteDistrict}
        />
      ),
      field: 'checkbox',
      align: 'left',
      sx: { backgroundColor: theme.palette.white.darker, width: '0%' },
    },
    {
      id: 1,
      content: (
        <>
          <TableTitle data-testid={ATSVacanciesModalTestIds.SCHOOL_VACANCIES_COLUMN_TITLE}>
            Locations
          </TableTitle>
          <TableSubtitle>Where might candidates be hired?</TableSubtitle>
        </>
      ),
      field: 'location',
      align: 'left',
      sx: { backgroundColor: theme.palette.white.darker, width: '33%' },
    },
    {
      id: 2,
      content: (
        <>
          <TableTitle data-testid={ATSVacanciesModalTestIds.SCHOOL_VACANCIES_COLUMN_TITLE}>
            Vacancies &nbsp;
          </TableTitle>
          <TableSubtitle>How many vacancies at this location?</TableSubtitle>
        </>
      ),
      field: 'vacancies',
      align: 'left',
      sx: { backgroundColor: theme.palette.white.darker, maxWidth: '120px', width: '40%' },
    },
    {
      id: 3,
      content: (
        <>
          <TableTitle data-testid={ATSVacanciesModalTestIds.SCHOOL_VACANCIES_COLUMN_TITLE}>
            {isHireLiteDistrict ? 'School user access' : 'School admin access'}
          </TableTitle>
          <TableSubtitle>
            {isHireLiteDistrict
              ? 'Can school users view candidates?'
              : 'Can admins view candidates?'}
          </TableSubtitle>
        </>
      ),
      field: 'isVisibleToSchoolAdmin',
      align: 'left',
      sx: {
        backgroundColor: theme.palette.white.darker,
        width: '33%',
        display: auth.inPostingOnlyDistrict() ? 'none' : 'table-cell',
      },
    },
  ];
};
